import { getContentBlockType, isContentBlockContext } from "../sessionStorage";

const eventVersion = 1;

export const enum EventName {
    integrationsClick = "vimeo.strategic_integrations_click",
    embed = "vimeo.strategic_integrations_embed",
    pageView = "vimeo.strategic_integrations_pageview",
    settingsChanged = "vimeo.integration_settings_changed",

    click = "vimeo.click",
    openAnalytics = "vimeo.open_analytics_drawer",
    openEmbedInEmail = "vimeo.open_embed_email_modal",
}

export const enum WorkflowEventNames {
    copyVideoLink = "workflow.copy_video_share_link",
    downloadVideoFile = "workflow.download_video_file",
    openCopyLinkModal = "workflow.open_video_link_share_modal",
    openDownloadModal = "workflow.open_download_modal",
}

export const enum Product {
    standaloneApp = "standalone_app",
    vimeoForEmail = "vimeo_for_email",
    vimeoForWeb = "vimeo_for_web",
}

export const enum SfmcLocation {
    appExchange = "app_exchange",
    emailStudio = "email_studio",
    cloudPages = "cloud_pages",
}

export const enum EmbedInEmailSource {
    appHome = "app_home",
    videoSettings = "video_settings",
    embedCta = "embed_cta",
}

export function configureAnalytics(userId: string) {
    const serviceUrl =
        window.location.hostname === "sfmc-qa.vimeo.com" ||
        window.location.hostname.endsWith("localhost")
            ? window.VimeoBigPictureClient.Service.FRESNEL_DEV
            : window.VimeoBigPictureClient.Service.FRESNEL_PROD;

    const globalEvent = getGlobalEvent(userId);

    const config = new window.VimeoBigPictureClient.Configuration(
        serviceUrl,
        globalEvent
    );
    window.VimeoBigPictureClient.BigPictureClient.configure(config);
}

export function getGlobalEvent(userId: string) {
    return {
        name: "vimeo.web_global", //constant
        ts_ms: Date.now(), //timestamp epoch milliseconds
        version: 5, //constant
        fields: {
            application: {
                application: "vimeo", //constant
                build_environment: "production", //constant
                product: "web", //constant
                version: {
                    full: "1.0.0", //constant
                    major: "1", //constant
                    minor: "0", //constant
                    patch: "0", //constant
                },
                vimeo_language: "en", //constant
            },
            platform: {
                device_language: window.navigator?.language || "", //client device language setting
                network: null, //constant
                platform: "web", //constant
                screen: {
                    dpi: window.screen.pixelDepth, //screen dpi
                    height: window.screen.height, //screen height
                    size: `${window.screen.width} x ${window.screen.height}`, //screen resolution
                    width: window.screen.width, //screen width
                },
            },
            user: {
                flags: [], //constant
                is_free_trial: false, //constant
                is_mod: false, //constant
                session_id: null, //constant
                subscription_type: null, //constant
                teams: null, //constant
                user_id: userId, //Vimeo user ID (very important!)
                vuid: null, //constant
            },
        },
    };
}

export function getProduct(): Product {
    const contentBlockProductType =
        getContentBlockType() === "email"
            ? Product.vimeoForEmail
            : Product.vimeoForWeb;
    return isContentBlockContext()
        ? contentBlockProductType
        : Product.standaloneApp;
}

export function getSfmcLocation(): SfmcLocation {
    const product = getProduct();

    // TODO: See if we can access the parent DOM's location, so we can know
    // for sure where they are accessing the content block product from
    // since they can technically load the two content blocks from either
    // Content Builder (email) or CloudPages (web).
    return product === Product.standaloneApp
        ? SfmcLocation.appExchange
        : product === Product.vimeoForEmail
        ? SfmcLocation.emailStudio
        : SfmcLocation.cloudPages;
}

export function sendAnalyticsEvent(
    name: EventName | WorkflowEventNames,
    fields: any,
    version = eventVersion,
    skipProductField = false
) {
    fields = {
        ...fields,
        third_party_integration: "sfmc",
    };
    
    if(!skipProductField){
        fields["product"] = getProduct()
    }

    const e = new window.VimeoBigPictureClient.Event(
        name,
        version,
        fields
    );
    try {
        window.VimeoBigPictureClient.BigPictureClient.sendEvent(e);
    } catch (err) {
        console.error("Error sending analytics event", err);
    }
}
